import { Col, Form, Row, Button, Modal, Spinner } from "react-bootstrap";
import "./Notification.css";
import React, { useEffect, useState, useCallback } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import { AgGridReact } from "ag-grid-react";
import Widgets from "../../components/Widgets";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { RxCrossCircled } from "react-icons/rx";
import { RiArrowDropDownLine } from "react-icons/ri";
import { FiPlus } from "react-icons/fi";
import { MdClear } from 'react-icons/md';
import { HiOutlinePencil } from "react-icons/hi";
import CustomPagination from "../../components/CustomPagination";
import CircularProgress from "../../components/CircularProgress";
import TableSkeleton from "../../components/table/TableSkeleton";


import {
  getNotificationsPath,
  notifyApproveRequestPath,
} from "../../services/config";

import { fetchData, initShiftState } from "../../redux/slices/shiftsSlice";
import {
  commonGetData,
  commonSaveData,
  initCommonState,
} from "../../redux/slices/commonSlice";
import {
  fetchBranchData,
  initBranchState,
} from "../../redux/slices/branchSlice";

import {
  getUniqueLocations,
  splitWaypoints,
  getSnapToRoadsWayPoints,
  getInitials,
  getInitialColor,
  getCapitalizeWord,
  notificationTitle,
  getTitleBtn,
} from "../../services/commonServices";


import Map from "../../components/Map/NotificationMap";
import { HasPermission } from "../../services/hasPermission";
import { Link, useNavigate } from "react-router-dom";
import SocialHub from "./SocialHub/index"
import OriginalNotification from "./OriginalNotification"

const Notification = () => {

  const navigate = useNavigate()

  const dispatch = useDispatch();
  const commonStore = useSelector((state) => state.common);
  const branchState = useSelector((state) => state.branch);
  const shiftState = useSelector((state) => state.shift);
  const themeStore = useSelector((state) => state.theme)

  const user = JSON.parse(localStorage.getItem("user_data") || "[]");

  const [countLeaves, setCountLeave] = useState({
    Leave: 0,
    Regularization: 0,
    Offsite: 0,
    Permission: 0,
    Other: 0,
  });

  const notificationTab = [
    <>
      <span>Leave</span>{" "}
      <div className="count-widgets"> {countLeaves.Leave} </div>
    </>,
    <>
      <span>Regularization</span>
      <div className="count-widgets"> {countLeaves.Regularization} </div>
    </>,
    <>
      <span>Offsite</span>
      <div className="count-widgets"> {countLeaves.Offsite} </div>
    </>,
    // <>
    //   <span>Permission</span>
    //   <div className="count-widgets"> {countLeaves.Permission} </div>
    // </>,
    <>
      <span>Other</span>{" "}
      <div className="count-widgets"> {countLeaves.Other} </div>{" "}
    </>,
    <span>Social Hub</span>
  ];

  const [activeTab, setActiveTab] = useState(0);
  const [description, setDescription] = useState([]);
  const [filterDescription, setFilterDescription] = useState([]);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [waypoints, setWaypoints] = useState([]);
  const [loadingWaypoints, setLoadingWaypoints] = useState(false);
  const [approveStatus, setApproveStatus] = useState({
    notifyId: "",
    staffId: "",
    approve: "",
    reason: "",
  });
  const [branch, setBranch] = useState([]);
  const [shift, setShift] = useState([]);
  const [fullscreen, setFullscreen] = useState(true);

  const [state, setState] = useState({
    userName: "",
    branchId: "",
    shiftId: "",
  });

  const [userData, setUserData] = useState({
    id: "",
    staffId: "",
    wishMessage: "",
    profileImage: "",
    staffName: "",
    employeeId: "",
  });

  const [selectedLeave, setSelectedLeave] = useState({});

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const getData = useCallback(() => {
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchData(user.user_id));
  }, [dispatch, user.user_id]);

  const getNotification = useCallback(() => {
    const path = `${getNotificationsPath}${user.user_id}`;
    dispatch(commonGetData(path));
  }, [dispatch, user.user_id]);

  // useEffect(() => {
  //   getData();
  //   getNotification();
  // }, [getData, getNotification]);

  useEffect(() => {
    getNotification();
  }, []);

  useEffect(() => {
    if (commonStore.commonGetSuccess) {
      if (activeTab) {
        if (commonStore.commonGetData) {
          const filtered =
            activeTab === 4
              ? commonStore.commonGetData.leaveRequests.filter(
                (v) => !["1", "2", "3", "4"].includes(v.referenceId)
              )
              : commonStore.commonGetData.leaveRequests.filter(
                (v) => v.referenceId === (activeTab + 1).toString()
              );
          setDescription(filtered);
        }
      } else {
        if (commonStore.commonGetData) {

          const newArr = commonStore.commonGetData?.leaveRequests?.filter(
            (v) => v.referenceId === "1"
          ) || [];
          setDescription(newArr);

          const leave = commonStore.commonGetData?.leaveRequests?.filter(
            (v) => v.referenceId === "1" && v.approved === "0"
          ) || [];

          const regularization = commonStore.commonGetData?.leaveRequests?.filter(
            (v) => v.referenceId === "2"
          ) || [];

          const offsite = commonStore.commonGetData?.leaveRequests?.filter(
            (v) => v.referenceId === "3" && v.approved === "0"
          ) || [];

          const permission = commonStore.commonGetData?.leaveRequests?.filter(
            (v) => v.referenceId === "4" && v.approved === "0"
          ) || [];

          const other = commonStore.commonGetData?.leaveRequests?.filter(
            (v) => !["1", "2", "3", "4"].includes(v.referenceId)
          ) || [];

          setCountLeave((pre) => ({
            ...pre,
            Leave: leave.length,
            Regularization: regularization.length,
            Offsite: offsite.length,
            Permission: permission.length,
            Other: other.length,
          }));

          getData();
        }

        setFilterDescription(commonStore.commonGetData.leaveRequests);
        dispatch(initCommonState())
      }
    }

    if (branchState.brnGetSuccess) {
      setBranch(branchState.brnGetData);
      dispatch(initBranchState());
    }

    if (shiftState.shiftGetSuccess) {
      setShift(shiftState.shiftGetData);
      dispatch(initShiftState());
    }
  }, [commonStore, branchState, shiftState, dispatch]);

  useEffect(() => {
    if (commonStore.commonSuccess) {
      toast.success(commonStore.commonMessage);
      dispatch(initCommonState());
      getNotification();
      handleCloseAllModals();
    } else if (commonStore.commonError) {
      toast.error(commonStore.commonMessage);
      dispatch(initCommonState());
      handleCloseAllModals();
    }
  }, [commonStore, dispatch, getNotification]);

  const handleCloseAllModals = () => {
    setShow(false);
    setShow1(false);
    setApproveStatus({
      notifyId: "",
      staffId: "",
      approve: "",
      reason: "",
    });
  };

  const handleTabIndex = (index) => {
    console.log(index)
    if (index == "Social Hub") {
      setActiveTab(index);
    } else {
      setState((prev) => ({ ...prev, userName: "", branchId: "", shiftId: "" }));
      setActiveTab(index);
      const filtered =
        index === 4
          ? filterDescription.filter(
            (v) => !["1", "2", "3", "4"].includes(v.referenceId)
          )
          : filterDescription.filter(
            (v) => v.referenceId === (index + 1).toString()
          );
      setDescription(filtered);
    }
  };

  const onChange = ({ target: { name, value } }) => {
    setState((prev) => ({ ...prev, [name]: value }));
    const filteredArray =
      activeTab === 4
        ? filterDescription.filter(
          (v) => !["1", "2", "3", "4"].includes(v.referenceId)
        )
        : filterDescription.filter(
          (v) => v.referenceId === (activeTab + 1).toString()
        );

    const filteredEmployees = filteredArray.filter((v) =>
      v.staffName.toLowerCase().includes(value.toLowerCase()) ||
      v.empId.toLowerCase().includes(value.toLowerCase())
    );

    setDescription(filteredEmployees);
  };

  const submitNotification = async (id, staffId, status, latLng = [], data) => {
    setSelectedLeave(data);

    setApproveStatus({
      notifyId: id,
      staffId,
      approve: status,
      reason: "",
    });

    if (latLng.length) {
      setLoadingWaypoints(true);
      const ll = splitWaypoints(latLng);
      const accurateData = await getSnapToRoadsWayPoints(ll);

      if (accurateData) {
        const uniqueLatLng = getUniqueLocations(accurateData);
        setWaypoints(uniqueLatLng);
      }
      setLoadingWaypoints(false);
    } else {
      setWaypoints([]);
    }

    setShow(true);
  };

  const handleReason = ({ target: { name, value } }) =>
    setApproveStatus((prev) => ({ ...prev, [name]: value }));

  const saveApprovalStatus = () => {
    const data = {
      path: notifyApproveRequestPath,
      data: {
        notifyId: approveStatus.notifyId,
        staffId: approveStatus.staffId,
        approve: approveStatus.approve,
        reason: approveStatus.reason,
      },
    };
    dispatch(commonSaveData(data));
  };

  const editData = (data) => {
    setUserData({
      id: data.id,
      staffId: data.staff_id,
      wishMessage: data.wishMessage,
      profileImage: data.profileImage,
      staffName: data.staffName,
      employeeId: data.empId,
    });
  };

  const heading = [
    {
      headerName: "SNo",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 60,
      pinned: "left",
    },
    {
      headerName: "Employee ID",
      pinned: "left",
      width: "120px",
      cellRenderer: (row) => row.data.empId
    },
    {
      headerName: "Employee Name",
      pinned: "left",
      width: "350px",
      cellRenderer: (row) => {
        return (
          <span
            // className="navigate-link"
            className="table-link d-flex align-items-center justify-content-start gap-2"
          >
            <div
              style={{
                width: "30px",
                height: "30px",
                border: "1px solid lightgray",
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: getInitialColor(row.data.staffName), // 🎯 Apply color
                color: "white", // Text contrast
                fontWeight: "bold",
                fontSize: "12px",
              }}
            >
              {getInitials(row.data.staffName)}
              {/* <img
                                src={Avatar}
                                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                              /> */}
            </div>
            {getCapitalizeWord(row.data.staffName)}
          </span>
        );
      },
    },
    { headerName: "Leave Type", width: "150px", cellRenderer: (row) => row.data.leave_name ? row.data.leave_name : "-" },
    { headerName: "From Date", width: "150px", cellRenderer: (row) => row.data.start_date ? row.data.start_date : "-" },
    { headerName: "To Date", width: "150px", cellRenderer: (row) => row.data.end_date ? row.data.end_date : "-" },
    {
      headerName: "Total Days",
      cellRenderer: (rowData) =>
        rowData.data.duration
          ? `${rowData.data.duration} ${rowData.data.duration > 1 ? "days" : "day"
          }`
          : "-",
      width: "100px",
    },
    {
      headerName: "Reason",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      width: "300px",
      cellRenderer: (row) => row.data.reason ? row.data.reason : "-"
    },
    {
      headerName: "Action",
      field: "id",
      width: 200,
      pinned: "right",
      cellRenderer: (rowData) =>
        rowData.data.approved === "0" ? (
          HasPermission("Leave", "approve") ||
            HasPermission("Leave", "reject") ? (
            <div className="d-flex align-items-center justify-content-end gap-2 notify-btn-wrapper">
              {HasPermission("Leave", "approve") && (
                <button
                  onClick={() =>
                    submitNotification(
                      rowData.data.id,
                      rowData.data.staff_id,
                      1,
                      rowData.data.latLongData,
                      rowData.data
                    )
                  }
                  className="approve-btn"
                >
                  Approve
                </button>
              )}

              {HasPermission("Leave", "reject") && (
                <button
                  onClick={() =>
                    submitNotification(
                      rowData.data.id,
                      rowData.data.staff_id,
                      2,
                      rowData.data.latLongData,
                      rowData.data
                    )
                  }
                  className="reject-btn"
                >
                  Reject
                </button>
              )}
            </div>
          ) : (
            "-"
          )
        ) : HasPermission("Leave", "approve") ||
          HasPermission("Leave", "reject") ? (
          <div
            className="status-wrapper"
            onClick={() =>
              submitPreNotification(
                rowData.data.id,
                rowData.data.staff_id,
                rowData.data.approved,
                rowData.data
              )
            }
          >
            <div className="approved-status">
              {rowData.data.approved === "1" ? (
                <div
                  className="d-flex align-items-center justify-content-start gap-2"
                  style={{ width: "100px" }}
                >
                  <IoCheckmarkCircleOutline className="approved-icon" />
                  <span className="approved-text">Approved</span>
                </div>
              ) : (
                <div
                  className="d-flex align-items-center justify-content-start gap-2"
                  style={{ width: "100px" }}
                >
                  <RxCrossCircled className="rejected-icon" />
                  <span className="rejected-text">Rejected</span>
                </div>
              )}
              <RiArrowDropDownLine className="status-dropdown" />
            </div>
          </div>
        ) : (
          "-"
        ),
    },
  ];

  const offsiteHeading = [
    {
      headerName: "SNo",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 60,
      pinned: "left",
    },
    {
      headerName: "Employee ID",
      field: "empId",
      pinned: "left",
      width: "120px",
    },
    {
      headerName: "Employee Name",
      pinned: "left",
      width: "350px",
      cellRenderer: (row) => {
        return (
          <span
            // className="navigate-link"
            className="table-link d-flex align-items-center justify-content-start gap-2"
          >
            <div
              style={{
                width: "30px",
                height: "30px",
                border: "1px solid lightgray",
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: getInitialColor(row.data.staffName), // 🎯 Apply color
                color: "white", // Text contrast
                fontWeight: "bold",
                fontSize: "12px",
              }}
            >
              {getInitials(row.data.staffName)}
              {/* <img
                                src={Avatar}
                                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                              /> */}
            </div>
            {getCapitalizeWord(row.data.staffName)}
          </span>
        );
      },
    },
    { headerName: "Leave Type", field: "leave_name", width: "150px", cellRenderer: (rowData) => rowData.data.leave_name ? rowData.data.leave_name : "-" },
    { headerName: "Start Time", field: "start_time", width: "120px", cellRenderer: (rowData) => rowData.data.start_time ? rowData.data.start_time : "-" },
    { headerName: "End Time", field: "end_time", width: "120px", cellRenderer: (rowData) => rowData.data.end_time ? rowData.data.end_time : "-" },
    {
      headerName: "Total Hours",
      cellRenderer: (rowData) =>
        rowData.data.duration
          ? `${rowData.data.duration} ${rowData.data.duration > 1 ? "days" : "day"
          }`
          : "-",
      width: "100px",
    },
    {
      headerName: "Start Reason",
      field: "reason",
      width: "200px",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      cellRenderer: (rowData) => rowData.data.reason ? rowData.data.reason : "-"
    },
    {
      headerName: "End Reason",
      field: "endReason",
      width: "200px",
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      cellRenderer: (rowData) => rowData.data.endReason ? rowData.data.endReason : "-"
    },
    // {
    //   headerName: "Action",
    //   field: "id",
    //   width: 200,
    //   pinned: "right",
    //   cellRenderer: (rowData) =>
    //     rowData.data.approved === "0" ? (
    //       HasPermission("Notifications", "edit") ? (
    //         <div className="d-flex align-items-center justify-content-end gap-2 notify-btn-wrapper">
    //           <button
    //             onClick={() =>
    //               submitNotification(
    //                 rowData.data.id,
    //                 rowData.data.staff_id,
    //                 1,
    //                 rowData.data.latLongData,
    //                 rowData.data
    //               )
    //             }
    //             className="approve-btn"
    //           >
    //             Approve
    //           </button>
    //           <button
    //             onClick={() =>
    //               submitNotification(
    //                 rowData.data.id,
    //                 rowData.data.staff_id,
    //                 2,
    //                 rowData.data.latLongData
    //               )
    //             }
    //             className="reject-btn"
    //           >
    //             Reject
    //           </button>
    //         </div>
    //       ) : (
    //         "-"
    //       )
    //     ) : HasPermission("Notifications", "edit") ? (
    //       <div
    //         className="status-wrapper"
    //         onClick={() =>
    //           submitPreNotification(
    //             rowData.data.id,
    //             rowData.data.staff_id,
    //             rowData.data.approved,
    //             rowData.data
    //           )
    //         }
    //       >
    //         <div className="approved-status">
    //           {rowData.data.approved === "1" ? (
    //             <div
    //               className="d-flex align-items-center justify-content-start gap-2"
    //               style={{ width: "100px" }}
    //             >
    //               <IoCheckmarkCircleOutline className="approved-icon" />
    //               <span className="approved-text">Approved</span>
    //             </div>
    //           ) : (
    //             <div
    //               className="d-flex align-items-center justify-content-start gap-2"
    //               style={{ width: "100px" }}
    //             >
    //               <RxCrossCircled className="rejected-icon" />
    //               <span className="rejected-text">Rejected</span>
    //             </div>
    //           )}
    //           <RiArrowDropDownLine className="status-dropdown" />
    //         </div>
    //       </div>
    //     ) : (
    //       "-"
    //     ),
    // },

    {
      headerName: "Action",
      field: "id",
      width: 200,
      pinned: "right",
      cellRenderer: (rowData) => {
        const approvedStatus = rowData.data.approved; // "0", "1", "2"
        const hasPermission = HasPermission("Offsite", "approve");
        const hasPermissionReject = HasPermission("Offsite", "reject");

        const handleApprove = () => {
          submitNotification(
            rowData.data.id,
            rowData.data.staff_id,
            1,
            rowData.data.latLongData,
            rowData.data
          );
        };

        const handleReject = () => {
          submitNotification(
            rowData.data.id,
            rowData.data.staff_id,
            2,
            rowData.data.latLongData,
            rowData.data
          );
        };

        const handlePreNotification = () => {
          submitPreNotification(
            rowData.data.id,
            rowData.data.staff_id,
            approvedStatus,
            rowData.data
          );
        };

        // If no permission
        if (!hasPermission && !hasPermissionReject) {
          return "-";
        }

        // If not yet approved
        if (approvedStatus === "0") {
          return (
            <div className="d-flex align-items-center justify-content-end gap-2 notify-btn-wrapper">
              {hasPermission && (
                <button onClick={handleApprove} className="approve-btn">
                  Approve
                </button>
              )}
              {hasPermissionReject && (
                <button onClick={handleReject} className="reject-btn">
                  Reject
                </button>
              )}
            </div>
          );
        }

        // If approved or rejected
        const statusIcon =
          approvedStatus === "1" ? (
            <IoCheckmarkCircleOutline className="approved-icon" />
          ) : (
            <RxCrossCircled className="rejected-icon" />
          );

        const statusText =
          approvedStatus === "1" ? (
            <span className="approved-text">Approved</span>
          ) : (
            <span className="rejected-text">Rejected</span>
          );

        return (
          <div className="status-wrapper" onClick={handlePreNotification}>
            <div
              className="approved-status d-flex align-items-center justify-content-between"
              style={{ width: "130px" }}
            >
              <div className="d-flex align-items-center gap-2">
                {statusIcon}
                {statusText}
              </div>
              <RiArrowDropDownLine className="status-dropdown" />
            </div>
          </div>
        );
      },
    },
  ];

  const heading1 = [
    {
      headerName: "SNo",
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 60,
      pinned: "left",
    },
    {
      headerName: "Employee ID",
      field: "empId",
      pinned: "left",
      width: "120px",
    },
    {
      headerName: "Employee Name",
      pinned: "left",
      width: "350px",
      cellRenderer: (row) => {
        return (
          <span
            // className="navigate-link"
            className="table-link d-flex align-items-center justify-content-start gap-2"
          >
            <div
              style={{
                width: "30px",
                height: "30px",
                border: "1px solid lightgray",
                borderRadius: "50%",
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: getInitialColor(row.data.staffName), // 🎯 Apply color
                color: "white", // Text contrast
                fontWeight: "bold",
                fontSize: "12px",
              }}
            >
              {getInitials(row.data.staffName)}
              {/* <img
                src={Avatar}
                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
              /> */}
            </div>
            {getCapitalizeWord(row.data.staffName)}
          </span>
        );
      },
    },
    {
      headerName: "Message",
      field: "wishMessage",
      flex: 1,
      autoHeight: true,
      wrapText: true,
      resizable: true,
      cellClass: "custom-wrap-cell",
      cellRenderer: (rowData) => rowData.data.wishMessage ? rowData.data.wishMessage : "-"
    },
    {
      headerName: "Action",
      pinned: "right",
      cellRenderer: (rowData) =>
        HasPermission("Notifications", "edit") ? (
          <HiOutlinePencil
            onClick={() => editData(rowData.data)}
            style={{
              cursor: "pointer",
              fontSize: 22,
              color: "#2e44c1",
              marginRight: "10px",
            }}
          />
        ) : (
          "-"
        ),
    },
  ];

  const submitPreNotification = (notifyId, staffId, approved, data) => {
    setApproveStatus({ notifyId, staffId, approve: approved, reason: "" });
    setShow1(true);
    setSelectedLeave(data);
  };

  const handleApprovedStatus = ({ target: { name, value } }) =>
    setApproveStatus((prev) => ({ ...prev, [name]: value }));

  const paginationPageSize = 10;

  const clearFilter = () => {
    setState((pre) => ({
      ...pre,
      branchId: "",
      shiftId: "",
      userName: "",
    }))
    getNotification()
    // submitDataForAdvance(`${year}-${month}`, state.branchId, state.shiftId);
  }

  const navigateToAddAnnouncement = () => {
    navigate("/add-announcement")
  }

  // --------------------------------------------------------------------------
  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />

      <Dialog
        open={show}
        keepMounted
        onClose={() => setShow(false)}
        maxWidth="sm" // 'xs', 'sm', 'md', 'lg', 'xl'
        fullWidth
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={() => setShow(false)}>
              X
            </span>
            <span className="title">
              {notificationTitle(activeTab, approveStatus.approve)}
              {/* {approveStatus.approve != "1" && activeTab == "0" ? "Reject Leave" : "Approve Leave"} */}
            </span>
          </div>

          {getTitleBtn(activeTab, approveStatus.approve).isButton && (
            <button className="universal-btn" onClick={saveApprovalStatus}>
              {getTitleBtn(activeTab, approveStatus.approve).text}
            </button>
          )}
        </DialogTitle>
        <DialogContent className="pure-dark-bg-color">
          {approveStatus.approve == "1" && activeTab == "0" && (
            <div>
              <div className="d-flex align-items-center justify-content-between mt-3">
                <div className="user-profile">
                  <span
                    // className="navigate-link"
                    className="d-flex align-items-center justify-content-start gap-2"
                  >
                    <div
                      style={{
                        width: "70px",
                        height: "70px",
                        border: "1px solid lightgray",
                        borderRadius: "50%",
                        overflow: "hidden",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: getInitialColor(
                          selectedLeave.staffName
                        ), // 🎯 Apply color
                        color: "white", // Text contrast
                        fontWeight: "bold",
                        fontSize: "12px",
                      }}
                      className="color-white"
                    >
                      {getInitials(selectedLeave.staffName)}
                      {/* <img
                                src={Avatar}
                                style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                              /> */}
                    </div>
                    <span>
                      <h3>{getCapitalizeWord(selectedLeave.staffName)}</h3>
                      <span className="color-gray" style={{ fontSize: "14px" }}>
                        {selectedLeave.empId}
                      </span>
                    </span>
                  </span>
                </div>
                <div className="leave-sections d-flex align-items-center justify-content-between gap-2">
                  <div className="d-flex flex-column align-items-center">
                    <span style={{ fontSize: "14px" }}>Paid Leave</span>
                    <CircularProgress
                      v1={1}
                      v2={2}
                      textSize="20"
                      textColor={themeStore.theme == "light" ? "#000" : "#fff"}
                      pathColor="#FFCB3E"
                      trailColor="gray"
                      strokeWidth="15"
                      width="70px"
                      height="70px"
                    />
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <span style={{ fontSize: "14px" }}>Casual Leave</span>
                    <CircularProgress
                      v1={1}
                      v2={2}
                      textSize="20"
                      textColor={themeStore.theme == "light" ? "#000" : "#fff"}
                      pathColor="#FF6557"
                      trailColor="gray"
                      strokeWidth="15"
                      width="70px"
                      height="70px"
                    />
                  </div>
                  <div className="d-flex flex-column align-items-center">
                    <span style={{ fontSize: "14px" }}>Sick Leave</span>
                    <CircularProgress
                      v1={1}
                      v2={2}
                      textSize="20"
                      textColor={themeStore.theme == "light" ? "#000" : "#fff"}
                      pathColor="#8660F8"
                      trailColor="gray"
                      strokeWidth="15"
                      width="70px"
                      height="70px"
                    />
                  </div>
                </div>
              </div>
              <hr />

              <div>
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <span className="color-gray">From Date</span>
                  <span>{selectedLeave.start_date}</span>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <span className="color-gray">From Date</span>
                  <span>{selectedLeave.end_date}</span>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <span className="color-gray">Total Days</span>
                  <span>{selectedLeave.duration}</span>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-2">
                  <span className="color-gray">Reason</span>
                  <span>{selectedLeave.reason}</span>
                </div>
              </div>
            </div>
          )}

          {(() => {
            if (approveStatus.approve == "1") {
              if (activeTab != "0" && activeTab != "2") {
                return (
                  <div className="d-flex align-items-center justify-content-center mt-4">
                    <h4>Are you sure! You Want to approve</h4>
                  </div>
                );
              }
            }
          })()}

          {approveStatus.approve == "1" &&
            activeTab != "0" &&
            activeTab != "2" && (
              <div className="d-flex align-items-center justify-content-center gap-3 mt-3 mb-3 ">
                <button
                  type="button"
                  style={{
                    width: "80px",
                    height: "35px",
                    backgroundColor: "transparent",
                    border: "1px solid gray",
                    borderRadius: "12px",
                  }}
                  onClick={() => setShow(false)}
                  className="color-white"
                >
                  No
                </button>
                <button
                  type="button"
                  style={{ width: "80px", height: "35px" }}
                  className="universal-btn"
                  onClick={saveApprovalStatus}
                >
                  Yes
                </button>
              </div>
            )}

          {approveStatus.approve != "1" && (
            <Form.Group className="mt-2">
              <Form.Control
                name="reason"
                value={approveStatus.reason}
                onChange={handleReason}
                placeholder="Enter reason"
                className="universal-input-one"
              />
            </Form.Group>
          )}

          {activeTab === 2 && (
            <Form.Group
              className="mt-3"
              style={{ width: "100%", height: "600px" }}
            >
              {<Map waypoint={waypoints} />}
            </Form.Group>
          )}
        </DialogContent>
      </Dialog>

      {/* ------------------ */}
      <Dialog
        open={show1}
        keepMounted
        onClose={() => setShow1(false)}
        maxWidth="sm" // 'xs', 'sm', 'md', 'lg', 'xl'
        fullWidth
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={() => setShow1(false)}>
              X
            </span>
            <span className="title">
              {notificationTitle(activeTab, approveStatus.approve)}
            </span>
          </div>
          <button className="universal-btn" onClick={saveApprovalStatus}>
            {approveStatus.approve != "1" ? "Reject" : "Approve"}
          </button>
        </DialogTitle>
        <DialogContent className="pure-dark-bg-color">
          <Form.Group className="mt-3">
            <select
              name="approve"
              value={approveStatus.approve}
              onChange={handleApprovedStatus}
              className="universal-input-one"
              style={{ width: "100%", paddingLeft: "10px" }}
            >
              <option value="1">Approved</option>
              <option value="2">Rejected</option>
            </select>
            {approveStatus.approve != "1" && (
              <Form.Control
                name="reason"
                value={approveStatus.reason}
                onChange={handleReason}
                placeholder="Enter reason"
                className="universal-input-one mt-2"
                style={{ borderRadius: "5px", border: "1px solid white" }}
              />
            )}
          </Form.Group>

          {activeTab == 2 && (
            <Form.Group
              className="mt-3"
              style={{ width: "100%", height: "600px" }}
            >
              {<Map waypoint={waypoints} />}
            </Form.Group>
          )}
        </DialogContent>
      </Dialog>

      <div className="notification-body">
        <Widgets
          body={
            <SocialHub />
          }
        />
      </div>

      {loadingWaypoints && (
        <div className="waypoints-loader">
          <span className="loader">
            <Spinner animation="border" variant="light" size="md" />
            <span>Loading...</span>
          </span>
        </div>
      )}
    </>
  );
};

export default Notification;
